import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_ENDPOINTS } from "./api/config";
import { useUser } from "./user_context";
import RemboLogo from "./components/RemboLogo";
import RemboMark from "./components/RemboMark";

const css = `
  .si-root *, .si-root *::before, .si-root *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .si-root {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: var(--color-text);
  }

  /* LEFT PANEL */
  .si-left {
    background: var(--color-bg-subtle);
    display: flex;
    flex-direction: column;
    padding: 3rem 4rem;
    position: relative;
    overflow: hidden;
  }
  .si-left::before {
    content: '';
    position: absolute;
    bottom: -120px; right: -120px;
    width: 400px; height: 400px;
    border-radius: 50%;
    border: 1px solid rgba(var(--color-primary-rgb),0.15);
  }
  .si-left::after {
    content: '';
    position: absolute;
    bottom: -60px; right: -60px;
    width: 250px; height: 250px;
    border-radius: 50%;
    border: 1px solid rgba(var(--color-primary-rgb),0.1);
  }
  .si-logo {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.7rem;
    font-weight: 600;
    color: var(--color-text);
    text-decoration: none;
    display: inline-block;
    margin-bottom: auto;
  }
  .si-logo span { color: var(--color-primary); }

  .si-form-area {
    padding: 2rem 0;
    max-width: 400px;
    width: 100%;
    animation: fadeUp 0.5s ease both;
  }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .si-eyebrow {
    font-size: 0.65rem;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--color-primary);
    margin-bottom: 0.75rem;
    display: flex; align-items: center; gap: 0.6rem;
  }
  .si-eyebrow::before {
    content: ''; display: block; width: 1.5rem; height: 1px; background: var(--color-primary);
  }
  .si-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 2.8rem;
    font-weight: 600;
    line-height: 1.1;
    color: var(--color-text);
    margin-bottom: 0.5rem;
  }
  .si-title em { font-style: normal; color: var(--color-primary); }
  .si-subtitle {
    font-size: 0.85rem;
    font-weight: 300;
    color: #777;
    margin-bottom: 2.5rem;
    line-height: 1.6;
  }
  .si-field {
    margin-bottom: 1.25rem;
  }
  .su-logo {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.7rem; font-weight: 600; color: var(--color-text);
    text-decoration: none; display: inline-block;
    margin-bottom: 2rem;
  }
  .su-logo span { color: var(--color-primary); }
  .su-eyebrow {
    font-size: 0.65rem; font-weight: 500; letter-spacing: 0.18em;
    text-transform: uppercase; color: var(--color-primary); margin-bottom: 0.75rem;
    display: flex; align-items: center; gap: 0.6rem;
  }
  .si-label {
    display: block;
    font-size: 0.7rem;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #555;
    margin-bottom: 0.5rem;
  }
  .si-input {
    width: 100%;
    padding: 0.85rem 1rem;
    background: #fff;
    border: 1px solid rgba(var(--color-text-rgb),0.15);
    border-radius: 2px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.9rem;
    font-weight: 300;
    color: var(--color-text);
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .si-input:focus {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb),0.1);
  }
  .si-input::placeholder { color: #bbb; }
  .si-input-wrap {
    position: relative;
  }
  .si-eye-btn {
    position: absolute; right: 0.75rem; top: 50%;
    transform: translateY(-50%);
    background: none; border: none; cursor: pointer;
    color: #aaa; font-size: 0.85rem; padding: 4px;
    transition: color 0.2s;
  }
  .si-eye-btn:hover { color: var(--color-primary); }
  .si-forgot {
    display: block;
    text-align: right;
    font-size: 0.78rem;
    color: var(--color-primary);
    text-decoration: none;
    margin-top: 0.4rem;
    transition: opacity 0.2s;
  }
  .si-forgot:hover { opacity: 0.7; }
  .si-btn {
    width: 100%;
    padding: 1rem;
    margin-top: 0.5rem;
    background: var(--color-text);
    color: var(--color-bg-subtle);
    border: none;
    border-radius: 2px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex; align-items: center; justify-content: center; gap: 0.5rem;
  }
  .si-btn:hover { background: var(--color-primary); color: var(--color-bg-subtle); }
  .si-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .si-divider {
    display: flex; align-items: center; gap: 1rem;
    margin: 1.5rem 0;
  }
  .si-divider::before, .si-divider::after {
    content: ''; flex: 1; height: 1px; background: rgba(var(--color-text-rgb),0.1);
  }
  .si-divider span {
    font-size: 0.72rem; color: #aaa; letter-spacing: 0.08em;
  }
  .si-switch {
    text-align: center;
    font-size: 0.82rem;
    color: #777;
  }
  .si-switch a {
    color: var(--color-primary); text-decoration: none; font-weight: 500;
  }
  .si-switch a:hover { text-decoration: underline; }
  .si-error {
    background: #fdf0f0;
    border: 1px solid rgba(220,50,50,0.2);
    border-radius: 2px;
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
    color: #c0392b;
    margin-bottom: 1.25rem;
    display: flex; align-items: center; gap: 0.5rem;
  }
  .si-success-msg {
    background: #f0faf4;
    border: 1px solid rgba(39,174,96,0.2);
    border-radius: 2px;
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
    color: #27ae60;
    margin-bottom: 1.25rem;
  }

  /* RIGHT PANEL */
  .si-right {
    background: var(--color-text);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4rem 3rem;
    position: relative;
    overflow: hidden;
    text-align: center;
  }
  .si-right::before {
    content: '';
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 600px; height: 600px; border-radius: 50%;
    border: 1px solid rgba(var(--color-primary-rgb),0.08);
  }
  .si-right::after {
    content: '';
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 350px; height: 350px; border-radius: 50%;
    border: 1px solid rgba(var(--color-primary-rgb),0.12);
  }
  .si-right-inner { position: relative; z-index: 1; max-width: 380px; }
  .si-panel-tag {
    font-size: 0.65rem; font-weight: 500; letter-spacing: 0.18em;
    text-transform: uppercase; color: var(--color-primary-light); margin-bottom: 1.5rem;
  }
  .si-panel-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 2.4rem; font-weight: 600; line-height: 1.1;
    color: var(--color-bg-subtle); margin-bottom: 1rem;
  }
  .si-panel-title em { font-style: normal; }
  .si-panel-text {
    font-size: 0.85rem; font-weight: 300; color: rgba(245,240,232,0.5);
    line-height: 1.8; margin-bottom: 2.5rem;
  }
  .si-perks { list-style: none; display: flex; flex-direction: column; gap: 1rem; text-align: left; }
  .si-perks li {
    display: flex; align-items: flex-start; gap: 0.75rem;
    font-size: 0.85rem; font-weight: 300; color: rgba(245,240,232,0.7); line-height: 1.5;
  }
  .si-perk-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: var(--color-primary-light); flex-shrink: 0; margin-top: 6px;
  }
  .si-panel-btn {
    display: inline-block; margin-top: 2.5rem;
    padding: 0.9rem 2rem;
    border: 1px solid rgba(var(--color-primary-rgb),0.4);
    border-radius: 2px; color: var(--color-primary-light);
    background: transparent;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.72rem; font-weight: 500;
    letter-spacing: 0.12em; text-transform: uppercase;
    cursor: pointer; transition: all 0.25s;
  }
  .si-panel-btn:hover { background: var(--color-primary-light); color: var(--color-bg-subtle); border-color: var(--color-primary-light); }

  .si-footer-note {
    font-size: 0.72rem; color: #999; margin-top: auto;
    line-height: 1.6;
  }
  .si-footer-note a { color: var(--color-primary); text-decoration: none; }

  @media (max-width: 900px) {
    .si-root { grid-template-columns: 1fr; }
    .si-right { display: none; }
    .si-left { padding: 2rem; }
    .si-form-area { max-width: 100%; }
  }
`;

const spinnerCss = `
  @keyframes spin { to { transform: rotate(360deg); } }
  .si-spinner {
    width: 16px; height: 16px; border-radius: 50%;
    border: 2px solid rgba(245,240,232,0.3);
    border-top-color: var(--color-bg-subtle);
    animation: spin 0.7s linear infinite;
  }
`;

  
export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Inject styles
  if (typeof document !== "undefined" && !document.getElementById("bl-si-css")) {
    const s = document.createElement("style");
    s.id = "bl-si-css";
    s.textContent = css + spinnerCss;
    document.head.appendChild(s);
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   if (!email || !password) { setError("Please fill in all fields."); return; }
  //   setLoading(true);
  //   // TODO: connect to .NET Core API — POST /api/auth/login
  //   await new Promise(r => setTimeout(r, 1400));
  //   setLoading(false);
  //   // Simulate error for demo
  //   setError("Invalid email or password. Please try again.");
  // };

      const { refreshUser } = useUser();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) { setError("Please fill in all fields."); return; }
    
    setLoading(true);

    try {
      // const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(API_ENDPOINTS.LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials");
      }

      // Save token and role
      localStorage.setItem("token", data.token);
      localStorage.setItem("userRole", data.user.role); // e.g., "jobseeker" or "employer"
      await refreshUser();
      // Redirect based on role
      if (data.user.role === "employer") {
        navigate("/employer/dashboard");
      } else {
        navigate("/dashboard");
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="si-root">
      {/* LEFT — form */}
      <div className="si-left">
        <Link to="/" className="su-logo"><RemboLogo theme="light" /></Link>

        <div className="si-form-area">
          <div className="si-eyebrow">Welcome Back</div>
          <h1 className="si-title">Sign in to your<br /><em>account</em></h1>
          <p className="si-subtitle">Access your dashboard, manage applications, and continue your journey.</p>

          {error && <div className="si-error"><span>⚠</span>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="si-field">
              <label className="si-label">Email Address</label>
              <input
                className="si-input"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div className="si-field">
              <label className="si-label">Password</label>
              <div className="si-input-wrap">
                <input
                  className="si-input"
                  type={showPw ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                  style={{ paddingRight: "2.5rem" }}
                />
                <button type="button" className="si-eye-btn" onClick={() => setShowPw(v => !v)}>
                  {showPw ? "🙈" : "👁"}
                </button>
              </div>
              <a href="#" className="si-forgot" onClick={e => { e.preventDefault(); navigate("/forgot-password"); }}>
                Forgot password?
              </a>
            </div>

            <button className="si-btn" type="submit" disabled={loading}>
              {loading ? <span className="si-spinner" /> : null}
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <div className="si-divider"><span>or</span></div>
          <div className="si-switch">
            Don't have an account?{" "}
            <a href="#" onClick={e => { e.preventDefault(); navigate("/signup"); }}>
              Create one
            </a>
          </div>
        </div>

        <p className="si-footer-note">
          By signing in you agree to our{" "}
          <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
        </p>
      </div>

      {/* RIGHT — brand panel */}
      <div className="si-right">
        <RemboMark size={220} variant="mono" className="si-right-watermark" />
        <div className="si-right-inner">
          <div className="si-panel-tag">The Beauty Industry Platform</div>
          <h2 className="si-panel-title">Your career,<br /><em>your craft</em></h2>
          <p className="si-panel-text">
            Thousands of beauty professionals and salon owners trust RemboList
            to make the right connections every day.
          </p>
          <ul className="si-perks">
            <li><span className="si-perk-dot" />Access your job applications and listings in one place</li>
            <li><span className="si-perk-dot" />Receive smart role matches based on your specialisation</li>
            <li><span className="si-perk-dot" />Message employers and candidates directly</li>
            <li><span className="si-perk-dot" />Track your hiring pipeline from first application to offer</li>
          </ul>
          <button className="si-panel-btn" onClick={() => navigate("/signup")}>
            New here? Create an account →
          </button>
        </div>
      </div>
    </div>
  );
}
